import { getSpecificEnv } from '@availity/env-var';
import { startsWith } from 'lodash';

const currentEnv = getSpecificEnv();
const { host = '' } = window.location;
const lowercaseHost = host?.toLowerCase();
const hasDotNet = lowercaseHost.indexOf('.net') >= 0;

const getCookieName = () => {
  let output;
  if (currentEnv === 'prod') {
    output = '3e2c59477f32ed6';
  } else if (currentEnv === 'qap') {
    output = '41628150c56c071';
  } else if (startsWith(currentEnv, 'q')) {
    output = '8cd219f60ec3052';
  } else {
    output = 'b3c95ac1e326997';
  }

  return output;
};

export const COOKIE_NAME = getCookieName();

const getOnPremCookieValues = () => {
  const output = [];
  if (currentEnv === 'prod') {
    output.push('rd3050o00000000000000000000ffff0a46300bo443', 'rd3050o00000000000000000000ffff0a47300bo443'); // need both AGP and DTP values
  } else if (currentEnv === 'qap') {
    output.push('rd3050o00000000000000000000ffff0a483053o443');
  } else if (startsWith(currentEnv, 'q')) {
    output.push('rd3050o00000000000000000000ffff0a483059o443');
  } else {
    output.push('rd3050o00000000000000000000ffff0a483086o443');
  }

  return output;
};

export const ONPREM_COOKIE_VALUES = getOnPremCookieValues();

const getAMUrl = () => {
  let output;
  if (currentEnv === 'prod') {
    output = `https://login-prod.availity${hasDotNet ? '.net' : '.com'}`;
  } else if (currentEnv === 'qap') {
    output = `https://login-qap.availity${hasDotNet ? '.net' : '.com'}`;
  } else if (startsWith(currentEnv, 'q')) {
    output = `https://login-qua.availity${hasDotNet ? '.net' : '.com'}`;
  } else {
    output = `https://login-tst.availity${hasDotNet ? '.net' : '.com'}`;
  }

  output = `${output}/am`;

  return output;
};

export const AM_URL = getAMUrl();
export const ENDUSER_CLIENT_ID = 'WebOAuthClient';
export const ADMIN_CLIENT_ID = 'WebOAuthClient';
export const THEME = 'default';
export const PLATFORM_UI_LOCALE = 'en';
export const REALM_PATH = 'alpha';

export const JOURNEY_LOGIN = 'avLogin';
export const JOURNEY_REGISTER = 'avUserRegistration';
export const JOURNEY_FORGOTTEN_USERNAME = 'avForgottenUsername';
export const JOURNEY_FORGOTTEN_PASSWORD = 'avForgottenPassword';
export const JOURNEY_UPDATE_PASSWORD = 'avUpdatePassword';
export const JOURNEY_LOGIN_AVSIMPLE = 'avSimple';
export const JOURNEY_SECURITY_QUESTIONS = 'avKBAManage';
export const JOURNEY_USER_AGREEMENT = 'SAND-TOSAndCA-v1';
export const JOURNEY_EMAIL_VERIFICATION = 'avEmailVerification';
export const JOURNEY_2FA_ENROLLMENT = 'avMFAEnrollment';
export const JOURNEY_2FA_CHALLENGE = 'avMFA';
export const JOURNEY_2FA_MANAGE = 'avMFAManage';
// export const JOURNEY_IAL2 = 'MK_IAL2-v1'; // TODO: update to final version when ready
export const JOURNEY_EPRO = 'avEProAccountLinking';
export const JOURNEY_SAML_INBOUND = 'avSAMLInbound';

// Tree Constants
export const TREE_SET_TOS_ACCEPTED = 'SAND-SetToSAccepted-v1';
